import { Switch } from '@mui/material';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import React from 'react';
import { useSelector } from 'react-redux';

const SettingOption = ({
    height,
    width,
    title,
    description,
    icon = 'lock',
    iconColor = '#212529',
    onClick = () => { },
    showToggle = true,
    toggleValue = false,
    isDelete = false,
    isDeleting = false,
    canMoveDown = true,
}) => {

    const { theme, editedProfile } = useSelector((state) => state.application);

    const { ref, focused, focusKey } = useFocusable({
        focusKey: `setting-option-${title}`,
        isFocusBoundary: true,
        onArrowPress: (direction) => {
            if (!canMoveDown && direction == 'down') {
                return false;
            }
            if (isDelete && direction == 'down') {
                return false;
            }
            return true;
        },
        onEnterRelease: onClick
    });

    return (
        <FocusContext.Provider value={focusKey}>
            <div ref={ref} style={{ height: height, width: width, display: "flex", alignItems: "center", justifyContent: isDelete ? "center" : "flex-start", backgroundColor: isDelete ? "#e84d31" : "white", borderRadius: "10px", padding: "10px", cursor: (showToggle && !isDelete) ? "default" : "pointer", border: focused ? "4px solid #007FFF" : "4px solid transparent" }} onClick={() => {
                if (!showToggle || isDelete) {
                    onClick();
                }
            }}>
                {
                    isDelete
                        ?
                        editedProfile?._id && <div style={{ color: "white", fontWeight: "bold", letterSpacing: "1px", }} >{isDeleting ? <i style={{ color: "white" }} className={"fa fa-spinner fa-spin fa-lg"} /> : "Delete Profile"}</div>
                        : <>
                            <i className={`fa fa-${icon} fa-lg`} style={{ color: iconColor }} />
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "95%" }}>
                                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: "15px", width: "80%" }}>
                                    <span style={{ fontSize: "16px", fontWeight: "bold", color: "black" }}>{title}</span>
                                    <span style={{ fontSize: "14px", fontWeight: "600", color: "grey", textWrap: "nowrap", overflow: "clip", textOverflow: "ellipsis" }}>{description}</span>
                                </div>
                                {showToggle ? <Switch onClick={onClick} checked={toggleValue} /> : <i className='fa fa-chevron-right fa-lg' style={{ color: "#212529" }} />}
                            </div></>
                }
            </div>
        </FocusContext.Provider>
    );
}

export default SettingOption;
